module.exports = "valuable"